<template>
  <transition name="fade">
    <div v-if="show" class="t-toast" :class="[{'bottom':position === 'bottom'},{'top':position === 'top'}]">
      <span>{{message}}</span>
    </div>
  </transition>
</template>
<script>
/**
   * @param position 显示位置top(顶部)，bottom(底部), 默认中间
   * @param message 提示文字
   * @describe 此组件为js调用组件详细见common调用方法
   *
   * @example
   *
    this.$toast({ message: '消息提示', position: 'top', });
   */
export default {
  name: 'toast',
  data() {
    return {
      position: '',
      message: '',
      show: false,
    };
  },
  mounted: function () {
    this.startTime();
  },
  methods: {
    startTime: function () {
      this.show = true;
      setTimeout(() => {
        this.show = false;
      }, 2000);
    },
  },
};

</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity .1s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}

.t-toast {
  z-index: 9999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
  max-width: 80%;
  padding: 0.08rem 0.1rem;
  border-radius: 0.05rem;
  background: rgba(0, 0, 0, .7);
  color: #fff;
  text-align: center;
  &.top {
    top: 0.5rem;
    transform: translate(-50%);
  }
  &.bottom {
    bottom: 0.5rem;
    transform: translate(-50%);
    top: auto;
  }
  &>span {
    font-size: 0.14rem;
    display: block;
    color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/toast.vue